<script setup lang="ts">
import { addIcons, OhVueIcon } from "oh-vue-icons";
import { computed, defineProps } from "vue";
import {
  MdSignalwifistatusbar1BarTwotone,
  MdSignalwifistatusbar2BarTwotone,
  MdSignalwifistatusbar3BarTwotone,
  MdSignalwifistatusbar4Bar,
  MdSignalwifistatusbarnotconnectedTwotone,
} from "oh-vue-icons/icons";

addIcons(
  MdSignalwifistatusbarnotconnectedTwotone,
  MdSignalwifistatusbar1BarTwotone,
  MdSignalwifistatusbar2BarTwotone,
  MdSignalwifistatusbar3BarTwotone,
  MdSignalwifistatusbar4Bar
);

const { rssi, scale } = defineProps<{
  rssi: number;
  scale: number;
}>();

const iconName = computed(() => {
  if (!rssi) {
    return "md-signalwifistatusbarnotconnected-twotone";
  }

  if (rssi > -50) {
    return "md-signalwifistatusbar4bar";
  } else if (rssi > -60) {
    return "md-signalwifistatusbar3bar-twotone";
  } else if (rssi > -70) {
    return "md-signalwifistatusbar2bar-twotone";
  } else if (rssi > -80) {
    return "md-signalwifistatusbar1bar-twotone";
  } else {
    return "md-signalwifistatusbarnotconnected-twotone";
  }
});
</script>

<template>
  <OhVueIcon :name="iconName" :scale="scale" />
</template>
